import React from 'react';
import ZealIcon from '../assets/zeal-icon.svg';
import ZealName from '../assets/zeal-name.svg';
import { Flex, Icon, Image } from '@zeal/web-ui';

export const APP_WEBSITE = import.meta.env.REACT_APP_WEBSITE ?? '';

export default function Banner({
	showBackButton = false,
	onBackButtonClick,
}: {
	showBackButton?: boolean;
	onBackButtonClick?: () => void;
}) {
	return (
		<Flex
			justify="center"
			align="center"
			className="p-4 w-full relative"
			style={{
				background:
					'radial-gradient(100% 100% at 50% 0%, #535DB5 0%, #000 60%)',
			}}
		>
			{showBackButton && (
				<Icon
					iconName="arrowLeft"
					variant="regular"
					colorVariant="white"
					size="lg"
					onClick={onBackButtonClick}
					className="cursor-pointer absolute left-5 top-5"
					data-testid="back-button"
				/>
			)}
			<Flex
				align="center"
				justify="center"
				style={{
					gap: '12.804px',
				}}
			>
				<Flex
					style={{
						width: '40.137px',
						height: '28px',
						flexShrink: 0,
					}}
				>
					<Image src={ZealIcon} alt="" />
				</Flex>
				<Flex
					style={{
						width: '41.929px',
						height: '14.9px',
						flexShrink: 0,
					}}
				>
					<Image src={ZealName} alt="Zeal" />
				</Flex>
			</Flex>
		</Flex>
	);
}
